import { handleActions } from 'redux-actions';
import initialState from './states';

import { biIncidentReportsByTypeSuccess, biIncidentReportsGroupedByDateAndTypeSuccess, biIncidentReportsGroupedByDateSuccess, setLoadingState } from './actions';
import { logoutSuccess } from 'ducks/auth/actions';

export default handleActions(
  {
    [biIncidentReportsByTypeSuccess](state, { payload }) {
      return {
        ...state,
        byType: payload,
      };
    },
    [biIncidentReportsGroupedByDateAndTypeSuccess](state, { payload }) {
      return {
        ...state,
        incidentReportsGroupedByDateAndType: payload,
      };
    },
    [biIncidentReportsGroupedByDateSuccess](state, { payload }) {
      return {
        ...state,
        incidentReportsGroupedByDate: payload,
      };
    },
    [setLoadingState](state, { payload }) {
      return {
        ...state,
        loading: payload,
      };
    },
    [logoutSuccess]() {
      return initialState;
    },
  },
  initialState
);
